import registerAdviceCommunication from "./adviceCommunication/AdviceCommunication";
import MultiFiltering from "./dynamicPageReload/init";
import { eventLoader } from "@otto-ec/global-resources/event-loader";
import { registerAppAdjustTracking } from "./appsTracking/AppsTracking";

eventLoader.onReady(3, () => {
  MultiFiltering.init();
  registerAppAdjustTracking();
});
registerAdviceCommunication();
